

module.exports = function($) {

    return {
        init: init
    };

    function init() {
        setVariationPrice();
        onAddToCart();
    }

    function setVariationPrice() {
        var variationRef = $('.product form.variations_form.cart');
        var priceRef = $('.product p.price');

        variationRef.on('show_variation', function(event, data) {
            priceRef.html(data.price_html).addClass('ready');
        });
    }

    function onAddToCart() {
        var modal = $('.modal.add-to-cart');
        var termsCheckbox = $('input#terms', modal);
        var checkoutButton = $('button', modal);
        var modalClose = $('[data-modal-dismiss]', modal);

        $('body').on('added_to_cart removed_from_cart', function() {
            modal
                .addClass('active');

            termsCheckbox.on('change', function() {
                var checked = termsCheckbox.is(':checked');
                if (checked) {
                    checkoutButton.attr('disabled', false);
                } else {
                    checkoutButton.attr('disabled', 'disabled');
                }
            });

            modalClose.on('click', function() {
                modal.removeClass('active');
            });
        });
    }
};
